<div class="modal-header justify-content-between">
    <h4 class="modal-title header-13">
        {{ configs.title }}
    </h4>
    <div class="d-flex">
        <span class="general-text-11 step-wrapper">{{configs.step}}</span>
        <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
      />
    </button>
    </div>
</div>

<div class="modal-body">
    @if(displayLoader) {
        <app-loading></app-loading>
    } @else {
        <app-dynamic-form [form]="dynamicForm" [formFields]="transformedFields" (modelChange)="onModelChange($event)"></app-dynamic-form>
    }
</div>

<div class="modal-footer">
    <p class="parameter-value-warning" *ngIf="missingParameterMessage">{{ missingParameterMessage }}</p>
    <div class="d-flex justify-content-end m-0">
        <button class=" btn-accello-secondary mx-2 open-btn" (click)="activeModal.dismiss('Cross click')"> Cancel </button>
        <button class=" btn-accello-primary-light open-btn" (click)="submit()" [disabled]="!dynamicForm?.valid || missingParameterNames.length > 0"> {{ configs.isEdit ? 'Update' : 'Add' }} </button>
    </div>
</div>